// Angular modules
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, withFetch, withInterceptors } from '@angular/common/http';
import { withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClient } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { withInMemoryScrolling } from '@angular/router';
import { withRouterConfig } from '@angular/router';

// External modules
import { TranslateModule } from '@ngx-translate/core';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AngularSvgIconModule } from 'angular-svg-icon';

// Internal modules
import { environment } from '@env/environment';
import { routes } from './app.routes';
import { httpLoadingInterceptor } from 'src/app/interceptors/http-loading.interceptor';

// Angular CDK modules
import { DragDropModule } from '@angular/cdk/drag-drop';

// Services
import { TitleService } from '@services/title.service';
import { TDS_I18N, vi_VN } from 'tds-ui/i18n';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ErrorInterceptor } from 'src/app/interceptors/http-error-interceptor';
import { authInterceptor } from './interceptors/auth.interceptor';
import { TDSEchartsModule } from 'tds-report';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: TDS_I18N, useValue: vi_VN },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    // Routing
    provideRouter(
      routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      }),
    ),

    importProvidersFrom(
      // Angular modules
      BrowserModule,
      DragDropModule,
      ScrollingModule,
      // External modules,
      TDSEchartsModule.forRoot({
        echarts: () => import('echarts')
      }),
      TranslateModule.forRoot({
        defaultLanguage: environment.defaultLanguage,
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        }
      }),
      AngularSvgIconModule.forRoot(),

      // Internal modules

    ),

    // External modules

    // Services
    TitleService,
    // Pipes
    DatePipe,

    // Guards

    // Resolvers

    provideHttpClient(
      withFetch(),
      withInterceptors([httpLoadingInterceptor, authInterceptor]),
      withInterceptorsFromDi()
    ),
    provideAnimations(),
    provideClientHydration(),
  ]
};